import DataTable from 'react-data-table-component';

const customStyles = {
    rows: {
        style: {
            minHeight: '72px', // override the row height
        },
    },
    headCells: {
        style: {
            fontSize: '5rem', // override the cell padding for head cells
            backgroundColor: 'var(--bg-base-color)',
            color: 'var(--base-white)',

        },
    },
    cells: {
        style: {
            paddingLeft: '8px', // override the cell padding for data cells
            paddingRight: '8px',
        },
    },
    contextMenu: {
        style: {
            fontSize: '25px',
            paddingLeft: '16px',
            paddingRight: '8px',
            borderRadius: '1.2rem',
            transform: 'translate3d(0, -100%, 0)',
            fontFamily: "'Montserrat', sans-serif",
            fontWeight: 700,
            transitionDuration: '125ms',
            transitionTimingFunction: 'cubic-bezier(0, 0, 0.2, 1)',
            willChange: 'transform',
            backgroundColor: 'var(--bg-background-color)'
        },
        activeStyle: {
            transform: 'translate3d(0, 0, 0)',
        },
    },
};

import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import CustomLoading from './Loading/CustomLoading';
import { useDispatch } from 'react-redux';
import { loaderAction } from '../redux/actions/Index';
import { environment } from './../env';
import axios from 'axios';
import { Button } from 'reactstrap';
import PdfDownload from './Modal/PDF/PdfDownload';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useMemo } from 'react';



const SelectTable = ({ columns, data, selectedProject, inves, resell, getInvestorProperties, update, showProperties, propertiesDetail, documentDetails, tenant, rentpay, allFormData, handelAllRent, selectedBuilding, selectedmonth }) => {
    const loader = useSelector((state) => state.ModalReducer?.loader)
    const SendFrom = useSelector((state) => state?.ModalReducer?.sendFrom);
    const navigate = useNavigate()
    const dispatch = useDispatch()


    const [tableData, setTableData] = useState(data)

    const Test = (propertiesData) => {
        dispatch(loaderAction());
        const SoldGalaDocPayLoad = new FormData();
        SoldGalaDocPayLoad.append("Investors", propertiesData?.Investors.id);
        SoldGalaDocPayLoad.append("gala", propertiesData?.gala.id);
        try {
            axios.post(`${environment.baseUrl}investors-properties-with-doc/`, SoldGalaDocPayLoad).then((docresponse) => {
                documentDetails(docresponse.data);
                dispatch(loaderAction());
            });
            showProperties(true);
        } catch (err) {
            dispatch(loaderAction());
            console.log(err);
        }
    };

    const getTenant = (data) => {
        try {
            axios.get(`${environment.baseUrl}tenant-gala-filter/?proposal=&building=&project=${data}`).then((res) => {
                tenant(res.data)
                dispatch(loaderAction());
            });
        } catch (err) {
            dispatch(loaderAction());
            console.log(err);
        }
    }
    
    useMemo(()=>{
    },[allFormData])

    const generateBill = () => {
        try {
            const investorPayLoad = new FormData();
            if(allFormData.billing_type == "" || (allFormData.billing_type != "rent" && allFormData.send_from == "")){
                toast.error('Select bill type and send from field properly', {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                  });
                return
            }
            let idArray = [];
            selectedRows.map(data => {
                let tempArray = [];
                data.rent.map(rentData => {
                    tempArray.push(rentData.id);
                })
                const individualObject = {
                    id: data.id,
                    rent_data_id : tempArray,
                }
                idArray.push(individualObject)
            })

            investorPayLoad.append('bill_type', allFormData.billing_type)
            investorPayLoad.append('send_from', allFormData.billing_type == "rent" ? SendFrom[0].id : allFormData.send_from)
            investorPayLoad.append('date', allFormData.month)
            investorPayLoad.append('invests_data', JSON.stringify({ids: idArray}))
            

            axios.post(`${environment.baseUrl}gen-rentpay`,investorPayLoad).then((res) => {
                dispatch(loaderAction());
                if (res.data.code === 200) {
                    handelAllRent(selectedProject, selectedBuilding, selectedmonth)
                    toast.success("Bill Genereted", {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 1500,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: false,
                    });
                }else if (form.data.code === 5005){
                    toast.error(res.data.code, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 1500,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: false,
                    });
                } 
            });
        } catch (err) {
            dispatch(loaderAction());
            console.log(err);
        }
    }

    const handleRowClicked = row => {
        if (inves != undefined) {
            if (resell != undefined) {
                propertiesDetail(row)
            } else {
                Test(row)
                getTenant(row.project.name)
                propertiesDetail(row)
            }
        } else {
            selectedProject(row.id)
            update(true)
            getInvestorProperties(row.id)
        }


        const updatedData = tableData.map(item => {

            item.toggleSelected = false;
            if (row.id !== item.id) {
                return item;
            }
            return {
                ...item,
                toggleSelected: true
            };
        });

        setTableData(updatedData);
    };
    const [selectedRows, setSelectedRows] = React.useState([]);
    const [toggleCleared, setToggleCleared] = React.useState(false);

    const handleRowSelected = React.useCallback(state => {
        if(allFormData != undefined){
            if(allFormData.billing_type == "" || allFormData.billing_type != 'rent' && allFormData.send_from == ""){
                toast.info('Select the type of bill, sending from and date first !!!', {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                });
                setSelectedRows([])
                return
            }
        }
        setSelectedRows(state.selectedRows);
    }, []);

    const contextActions = React.useMemo(() => {
        const handleDelete = () => {
            if (window.alert(`Are you sure you want to delete:\r ${selectedRows.map(r => r.title)}?`)) {
                setToggleCleared(!toggleCleared);
                setTableData(differenceBy(tableData, selectedRows, 'title'));
            }
        };

        const navigatePrint = () => {
            navigate('/PrintPreview', { state: { pay: rentpay } })
        }

        return (
            <div className='d-flex gap-3'>
                <button className="border-radius-7 p-3 d-flex align-items-center buttons btn btn-secondary" onClick={generateBill}><span className="fs-4 d-flex gap-3 title-font-600 px-3">Generate Bill</span></button>
                <button className="border-radius-7 p-3 d-flex align-items-center buttons btn btn-secondary" onClick={navigatePrint}><span className="fs-4 d-flex gap-3 title-font-600 px-3">Print Bill</span></button>
                {/* <button className="border-radius-7 p-3 d-flex align-items-center buttons btn btn-secondary" ><span className="fs-4 d-flex gap-3 title-font-600 px-3">Send Email</span></button> */}
            </div>
        );
    }, [selectedRows, toggleCleared, tableData]);
    useEffect(() => {
        setTableData(data);
    }, [data])
    return (
        <DataTable
            title="Billing"
            customStyles={customStyles}
            columns={columns}
            data={tableData}
            onRowClicked={handleRowClicked}
            highlightOnHover
            selectableRows
            contextActions={contextActions}
            onSelectedRowsChange={handleRowSelected}
            clearSelectedRows={toggleCleared}
            progressPending={loader}
            progressComponent={<CustomLoading />}
            pagination
            paginationPerPage={10}
            paginationRowsPerPageOptions={[5, 10, 15, 25, 50]}
            paginationComponentOptions={{
                rowsPerPageText: 'Records per page:',
                rangeSeparatorText: 'out of',
            }}
        />
    )
}

export default SelectTable